import React from 'react'
import { DOMAttributes, useRef } from 'react'
import { useOverlay, mergeProps, DismissButton } from 'react-aria'
import { Box } from '../../../../core-components'
import { SafeFocusScope } from '../../../../internal-helpers/SafeFocusScope'

type Props = DOMAttributes<unknown> & { onClose: () => void }
export const YearMonthSelectPopover = ({ children, onClose, ...overlayProps }: Props) => {
  const popoverRef = useRef<HTMLDivElement>(null)
  const { overlayProps: ownOverlayProps } = useOverlay(
    {
      isOpen: true,
      onClose,
      isDismissable: true,
    },
    popoverRef
  )
  return (
    <Box
      overflow='auto'
      position='absolute'
      top={9}
      bg='bg/dropdown'
      bottom={0}
      left={0}
      right={0}
      px={2}
    >
      <SafeFocusScope restoreFocus contain>
        <div ref={popoverRef} {...mergeProps(overlayProps, ownOverlayProps)}>
          {children}
          <DismissButton onDismiss={onClose} />
        </div>
      </SafeFocusScope>
    </Box>
  )
}
